import Image from "components/Image"

import { ComponentProps } from "."
import Detail from "./Detail"
import { Right, Title, Wrapper } from "./styled"

const Details = ({
  actors,
  country,
  director,
  language,
  plot,
  poster,
  rating,
  releaseDate,
  runtime,
  title,
  writer
}: ComponentProps) => (
  <Wrapper>
    {poster ? (
      <Image
        alternativeText={poster.alternativeText}
        filename={poster.filename}
        formats={poster.formats}
        height={poster.height}
        url={poster.url}
        width={poster.width}
      />
    ) : null}

    <Right>
      <Title>{title}</Title>

      {director ? <Detail label="Director" text={director} /> : null}

      <Detail label="Actors" text={actors} />

      {plot ? (
        <Detail isExpandable isMarkdown label="Plot" text={plot} />
      ) : null}

      {writer ? <Detail label="Writers" text={writer} /> : null}

      <Detail label="Release Date" text={releaseDate} />

      {runtime ? <Detail label="Runtime" text={runtime} /> : null}

      {rating ? <Detail label="Rating" text={rating} /> : null}

      <Detail label="Country" text={country} />

      <Detail label="Language" text={language} />
    </Right>
  </Wrapper>
)

export default Details
